export const HighCostLicenseDetailsStyles = {
  container: (isMobile: boolean) => `mt-15px mr-15px ${isMobile ? 'ml-15px' : 'ml-auto'} p-7px max-w-fit text-center bg-white border-solid border-3 border-barneyPurple rounded-md`,
  provinceLabel: 'text-13px text-black font-bold',
  expiryLabel: 'text-12px text-black',
};
